import styled from 'styled-components';

const MenuBarStyle = styled.div`
	--menuBarItemDistance: var(--sp11x);

	display: flex;
	align-items: center;
	z-index: 11;

	.menu-bar-block {
		display: flex;
		align-items: center;
		gap: var(--menuBarItemDistance);
	}

	.menu-bar-item-link {
		position: relative;
	}

	&.burger-version {
		.btn {
			display: none;
			pointer-events: none;
		}
	}

	/* //! For Desktop Hover */
	@media only screen and (min-width: 1024px) {
		.menu-bar-item-link {
			&.hover-type {
				opacity: 0.5;
				transition: opacity var(--trTime) ease-out;

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							opacity: 1;
						}
					}
				}
			}

			&.active {
				opacity: 1;
			}
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--menuBarItemDistance: var(--sp9x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--menuBarItemDistance: var(--sp7x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--menuBarItemDistance: var(--sp6x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--menuBarItemDistance: var(--sp5x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--menuBarItemDistance: var(--sp3x);

		display: unset;
		align-items: unset;

		&.burger-version {
			.btn {
				display: flex;
				pointer-events: all;
			}

			.menu-bar-inner-container {
				padding: var(--sp5x) var(--sp2x);
			}

			.menu-bar-item {
				color: var(--green1000);

				&:before {
					background-color: var(--green1000);
				}
			}
		}

		.menu-bar-item-link {
			&.hover-type {
				.menu-bar-item {
					color: #39442b80;
				}

				&.active {
					pointer-events: none;

					.menu-bar-item {
						color: var(--green1000);
					}
				}
			}
		}
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		/* --menuBarItemDistance: var(--sp5x); */
		--menuBarItemDistance: var(--sp3x);
	}
`;

export default MenuBarStyle;
